import { render, staticRenderFns } from "./LinkedUserList.vue?vue&type=template&id=07daabee"
import script from "./LinkedUserList.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkedUserList.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports